import React from "react";


// reactstrap components
import {
  Container,
  Row,
  Col,
  Card,
  Carousel,
  CarouselItem,
  CarouselIndicators
} from "reactstrap";

// core components
// carousel items
const carouselItems = [
  {
    src: require("assets/img/sections/fondo1.jpg"),
    altText: "Ver cotizador",
    caption: "Somewhere",
    texto:
      "En este módulo podrá realizar las cotizaciones previas a sus escrituras de: Compraventa, Compraventa e hipoteca con particulares y/o entidades financieras, Hipotecas, cancelaciones de hipoteca, matrimonios y sucesiones, entre otras",
    boton: "Ver Cotizador",
    titulo: 'Cotizador en Linea',
    ruta: "/cotizador" 
  },
  {
    src: require("assets/img/sections/bogota13.jpg"),
    altText: "Facturación Electrónica",
    caption: "Somewhere else",
    texto: "Ya facturamos electrónicamente ante la Dian. Lo esperamos",   
    titulo: 'Facturación Electrónica',
    boton: "Información",
    ruta: "#contact-us" 
  },
  /* {
    src: require("assets/img/sections/bogota14.jpg"),
    altText: "Here it is",
    caption: "Here it is",
    texto: "This is a simple hero unit, a simple jumbotron-style component for calling extra attention to featured content or information.",
    boton: "Ver Más",
    titulo: 'Noticia 03',
    ruta: "#" 
  } */
];

function SectionComponents() {
  // carousel states and functions
  const [activeIndex, setActiveIndex] = React.useState(0);
  const [animating, setAnimating] = React.useState(false);
  const onExiting = () => {
    setAnimating(true);
  };
  const onExited = () => {
    setAnimating(false);
  };
  const next = () => {
    if (animating) return;
    const nextIndex =
      activeIndex === carouselItems.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  };
  const previous = () => {
    if (animating) return;
    const nextIndex =
      activeIndex === 0 ? carouselItems.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  };
  const goToIndex = newIndex => {
    if (animating) return;
    setActiveIndex(newIndex);
  };
  return (
    <>
      <div
        className="section section-components cd-section section-dark"
        style={{ paddingBottom: "40px" }}
        id="aplicativos"
      >
        <Row>
          <Col className="col-lg-6 offset-lg-1" md="12">
            <Card className="card-raised page-carousel">
              <Carousel
                activeIndex={activeIndex}
                next={next}
                previous={previous}
              >
                <CarouselIndicators
                  items={carouselItems}
                  activeIndex={activeIndex}
                  onClickHandler={goToIndex}
                />
                {carouselItems.map((item,index) => {
                  return (
                    <CarouselItem
                      onExiting={onExiting}
                      onExited={onExited}
                      key={index}
                    >
                      <div
                        className="jumbotron carousel-slide-custom"
                        style={{
                          minHeight: '340px',
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'center',
                          alignItems: 'center',
                          borderRadius: '1.5em',
                          boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.15)',
                          background: '#fff',
                          padding: '2em 1.5em',
                          margin: '0.5em',
                          border: '1px solid #e3e3e3',
                          transition: 'box-shadow 0.3s',
                        }}
                      >
                        <div style={{
                          background: 'transparent',
                          borderRadius: '1em',
                          padding: '1em',
                          width: '100%',
                          maxWidth: '420px',
                          boxShadow: 'none'
                        }}>
                          <h2
                            className="text-center font-weight-bold"
                            style={{
                              fontSize: '1.3em',
                              marginBottom: '0.7em',
                              color: '#379C11',
                              letterSpacing: '0.02em'
                            }}
                          >
                            {item.titulo}
                          </h2>
                          <p
                            className="lead text-center"
                            style={{
                              padding: "0.5em 1em",
                              fontSize: '1.05em',
                              color: '#222',
                              marginBottom: '1em'
                            }}
                          >
                            {item.texto}
                          </p>
                          <div className="text-center mt-auto">
                            <a className="btn btn-success btn-round shadow-sm"
                              style={{
                                fontSize: '1em',
                                padding: '0.6em 2em',
                                borderRadius: '2em',
                                fontWeight: 'bold',
                                boxShadow: '0 2px 8px 0 rgba(55,156,17,0.15)',
                                border: 'none',
                                backgroundColor: '#379C11',
                                color: 'white',
                                transition: 'background 0.2s'
                              }}
                              href={item.ruta} role="button"
                            >{item.boton}</a>
                          </div>
                        </div>
                      </div>
               
                    </CarouselItem>
                  );
                })}
                <a
                  className="left carousel-control carousel-control-prev"
                  data-slide="prev"
                  href="#pablo"
                  onClick={e => {
                    e.preventDefault();
                    previous();
                  }}
                  role="button"
                >
                  <span className="fa fa-angle-left" />
                  <span className="sr-only">Previous</span>
                </a>
                <a
                  className="right carousel-control carousel-control-next"
                  data-slide="next"
                  href="#pablo"
                  onClick={e => {
                    e.preventDefault();
                    next();
                  }}
                  role="button"
                >
                  <span className="fa fa-angle-right" />
                  <span className="sr-only">Next</span>
                </a>
              </Carousel>
            </Card>
          </Col>
          <Col lg="4" md="10">
            <Container
              className="basic-container"
              style={{ marginLeft: "7em" }}
            >
              <span className="">
                <h1
                  className="display-2 text-white font-weight-bolder"
                  style={{ margin: "104px 0px 0px" }}
                >
                  Noticias
                </h1>
              </span>
            </Container>
          </Col>
        </Row>
      </div>
      {/* Responsive styles para el carrusel mejorado */}
      <style>{`
        @media (max-width: 991px) {
          .section-components .basic-container {
            margin-left: 0 !important;
            margin-top: 0 !important;
            padding: 0 !important;
          }
        }
        @media (max-width: 576px) {
          .section-components .card-raised {
            margin-left: 0 !important;
            margin-right: 0 !important;
          }
          .section-components .basic-container {
            margin-left: 0 !important;
            margin-top: 0 !important;
            padding: 0 !important;
          }
          .section-components .display-2 {
            font-size: 1.3em !important;
            margin: 1em 0 0 0 !important;
          }
          .section-components .carousel-slide-custom {
            padding: 1em 0.5em !important;
            min-height: 220px !important;
            margin: 0.2em !important;
            border-radius: 1em !important;
          }
          .section-components .page-carousel {
            margin-bottom: 1em !important;
          }
        }
      `}</style>
    </>
  );
}

export default SectionComponents;
